<div class="main_body">
  <div class="contents contents--user-movie">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="media_upload_area"
          [class.drag-over]="dragOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          @if (dragOver) {
            <div class="drop-overlay">
              <mat-icon>cloud_upload</mat-icon>
              <span i18n="@@home.userMedia.label.dropHere">ここにファイルをドロップ</span>
            </div>
          }
          <div class="uploadfile">
            <button mat-flat-button color="primary" class="upload-button"
              (click)="mediaFileInputClick()">
              <mat-icon class="upload-button__icon" aria-hidden="true" translate="no">upload_file</mat-icon>
              <span i18n="@@home.userMedia.button.selectFile">ファイルを選択</span>
            </button>
            <span class="file-name" aria-live="polite"
              [class.file-name--empty]="!selectedFile">
              {{selectedFileName || fileNotSelectedText}}
            </span>
            <input class="hidden" type="file"
              accept="video/mp4, video/quicktime, video/x-msvideo, video/x-ms-wmv, video/x-flv, video/x-matroska, image/jpeg, image/gif, image/png"
              (change)="onFileChange($event)"
              #mediaFileInput>
          </div>
          <div class="drop-hint">
            <mat-icon>cloud_upload</mat-icon>
            <span i18n="@@home.userMedia.hint.dragDrop">ファイルをドラッグ＆ドロップでも選択できます</span>
          </div>
          @if (submitted && !selectedFile) {
            <div class="inline-error" i18n="@@home.userMedia.error.fileRequired">
              <mat-icon>error_outline</mat-icon>ファイルを選択してください
            </div>
          }
          <div class="form-section">
            <span class="upload-form-label" i18n="@@home.userMedia.label.type">種別（必須項目）：</span>
            <mat-radio-group aria-label="種別" [(ngModel)]="method">
              <mat-radio-button value="VE">VE</mat-radio-button>
              <mat-radio-button value="VF">VF</mat-radio-button>
              <mat-radio-button value="VS">VS</mat-radio-button>
              <mat-radio-button value="Others" i18n="@@home.userMedia.option.others">その他</mat-radio-button>
            </mat-radio-group>
            @if (submitted && method === '') {
              <div class="inline-error" i18n="@@home.userMedia.error.typeRequired">
                <mat-icon>error_outline</mat-icon>種別を選択してください
              </div>
            }
          </div>
          <div class="video_comment">
            <textarea class="comment_add"
              placeholder="コメントを追加（ファイルが選択されるとファイル名が追加されます）"
              [(ngModel)]="message"
              i18n-placeholder="@@home.userMedia.placeholder.comment"></textarea>
          </div>
        </div>
        <div class="btn-group btn-group--right">
          @if (uploading) {
            <div class="progress">
              <mat-progress-bar mode="determinate" [value]="uploadProgress" />
              <span class="progress-text" i18n="@@home.userMedia.label.uploadProgress">アップロード: {{uploadProgress}} %</span>
            </div>
          } @else {
            <button mat-stroked-button (click)="clearForm()"
              [disabled]="!hasFormInput"
              i18n="@@home.userMedia.button.clear">
              クリア
            </button>
            <button mat-flat-button color="primary" (click)="createMediaRecord()"
              i18n="@@home.userMedia.button.upload">
              アップロード
            </button>
          }
        </div>
      </section>

      <section class="contents__section contents__section--media-grid">

        <!-- Table Toolbar -->
        <div class="table-toolbar">
          <!-- Left: spacer (検索は廃止) -->
          <div class="table-toolbar__spacer"></div>

          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            <button
              mat-icon-button
              type="button"
              class="table-toolbar__btn"
              (click)="refreshMediaList()"
              [disabled]="uploading || refreshing"
              [matTooltip]="i18n.button.refresh"
              [attr.aria-label]="i18n.button.refresh">
              <mat-icon>refresh</mat-icon>
            </button>
            <div class="view-toggle" role="group" aria-label="表示切替">
              <button mat-icon-button
                [class.view-toggle--active]="viewMode() === 'gallery'"
                (click)="viewMode.set('gallery')"
                [matTooltip]="i18n.view.gallery"
                [attr.aria-label]="i18n.view.gallery">
                <mat-icon>grid_view</mat-icon>
              </button>
              <button mat-icon-button
                [class.view-toggle--active]="viewMode() === 'list'"
                (click)="viewMode.set('list')"
                [matTooltip]="i18n.view.list"
                [attr.aria-label]="i18n.view.list">
                <mat-icon>view_list</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Gallery View -->
        @if (viewMode() === 'gallery') {
          <div class="media-card-grid" [class.is-refreshing]="refreshing">
            @for (res of mediasList; track res.id) {
              <div class="card">
                <div class="card-header">
                  @if (isUnavailableMedia(res)) {
                    <div class="encoding-placeholder">
                      <div class="encoding-status">
                        <mat-icon class="encoding-icon encoding-icon--static" [class.error-icon]="isErrorStatus(res.data.mediaStatus)">
                          {{ isDeletedStatus(res.data.mediaStatus) ? 'delete_outline' : 'error_outline' }}
                        </mat-icon>
                        <span>{{ getStatusLabel(res.data.mediaStatus) }}</span>
                      </div>
                    </div>
                  } @else {
                    @if (isImageMedia(res)) {
                      @if (isImagePending(res)) {
                        <div class="encoding-placeholder">
                          <div class="encoding-shimmer"></div>
                          <div class="encoding-status">
                            <mat-icon class="encoding-icon">hourglass_top</mat-icon>
                            <span>{{ getStatusLabel(res.data.mediaStatus) }}</span>
                          </div>
                        </div>
                      } @else {
                        <img [src]="getThumbnailUrl(res)" (error)="onThumbnailError($event, res)" alt="">
                      }
                    }
                    @if (isVideoMedia(res)) {
                      @if (isVideoPending(res)) {
                        <div class="encoding-placeholder">
                          <div class="encoding-shimmer"></div>
                          <div class="encoding-status">
                            <mat-icon class="encoding-icon">hourglass_top</mat-icon>
                            <span>{{ getStatusLabel(res.data.mediaStatus) }}</span>
                          </div>
                        </div>
                      }
                      @if (isVideoEncoded(res)) {
                        <app-media-video-player
                          [playerInstance]="getPlayerInstance(res.id)"
                          [thumbnailUrl]="getThumbnailUrl(res)">
                          <div class="video-container" [attr.resid]="res.id" #mkplayerdiv></div>
                        </app-media-video-player>
                      }
                    }
                  }
                </div>
                <div class="card-body">
                  <div class="card-body__link card-body--link" (click)="navigateToDetail(res)" role="link" tabindex="0"
                    (keydown.enter)="navigateToDetail(res)">
                    <div>
                      @if (isImageMedia(res)) {
                        <span class="tag tag-text" i18n="@@home.userMedia.label.image">静止画</span>
                      }
                      @if (isVideoMedia(res)) {
                        <span class="tag tag-text" i18n="@@home.userMedia.label.video">動画</span>
                      }
                      @if (res.data.method === 'VE') {
                        <span class="tag tag-darkred">VE</span>
                      }
                      @if (res.data.method === 'VF') {
                        <span class="tag tag-purple">VF</span>
                      }
                      @if (res.data.method === 'VS') {
                        <span class="tag tag-khaki">VS</span>
                      }
                      @if (res.data.method === 'Others') {
                        <span class="tag tag-silver">Others</span>
                      }
                    </div>
                    <div class="card-media-comment-content">
                      <h5 i18n="@@home.userMedia.label.comment">コメント：</h5>
                      <p>{{res.data?.comment}}</p>
                    </div>
                    <div class="user">
                      <div class="user-info">
                        <h5 i18n="@@home.userMedia.label.createdAt">作成日：</h5>
                        <small>{{res.data.createdAt | date:"yyyy/MM/dd"}}</small>
                      </div>
                    </div>
                  </div>
                  <div class="card-actions">
                    <button mat-stroked-button (click)="downloadMedia(res.id)" class="file-button">
                      <mat-icon aria-hidden="true" translate="no">download</mat-icon>
                      <span i18n="@@home.userMedia.button.download">ダウンロード</span>
                    </button>
                    &nbsp;
                    <button mat-stroked-button (click)="confirmDeleteMedia(res.id)" class="file-button">
                      <mat-icon aria-hidden="true" translate="no">delete</mat-icon>
                      <span i18n="@@home.userMedia.button.delete">削除</span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <!-- List View -->
        @if (viewMode() === 'list') {
          <div class="media-list-container" [class.is-refreshing]="refreshing">
            <table mat-table [dataSource]="mediasList" class="user_record_table media-list-table"
              matSort matSortDisableClear
              [matSortActive]="sortActive"
              [matSortDirection]="sortDirection"
              (matSortChange)="onSortChange($event)">

              <!-- Created At -->
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ i18n.list.createdAt }}</th>
                <td mat-cell *matCellDef="let row">{{ row.data.createdAt | date:'yyyy/MM/dd HH:mm' }}</td>
              </ng-container>

              <!-- Method -->
              <ng-container matColumnDef="method">
                <th mat-header-cell *matHeaderCellDef>{{ i18n.list.method }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="protocol-cell">
                    <span class="protocol-cell__primary">{{ row.data.method }}</span>
                    <span class="protocol-cell__secondary">
                      @if (isImageMedia(row)) { 静止画 } @else { 動画 }
                    </span>
                  </span>
                </td>
              </ng-container>

              <!-- Comment -->
              <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef>{{ i18n.list.comment }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="media-list-comment"
                    [matTooltip]="row.data.comment || ''"
                    matTooltipShowDelay="300">
                    {{ row.data.comment || '—' }}
                  </span>
                </td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="mediaStatus">
                <th mat-header-cell *matHeaderCellDef>{{ i18n.list.status }}</th>
                <td mat-cell *matCellDef="let row">
                  <span class="media-list-status"
                    [class.media-list-status--encoding]="isEncodingLikeStatus(row.data.mediaStatus)"
                    [class.media-list-status--done]="isDoneStatus(row.data.mediaStatus)"
                    [class.media-list-status--error]="isErrorStatus(row.data.mediaStatus)">
                    {{ getStatusLabel(row.data.mediaStatus) }}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                (click)="navigateToDetail(row)"
                role="link"
                class="media-list-row"></tr>
            </table>
          </div>
        }

        <!-- Shared Paginator -->
        <mat-paginator class="user-list-paginator"
          [class.is-refreshing]="refreshing"
          [length]="paginatorLength"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </section>
    </div>
  </div>
</div>
